let fbqLoaderInjected = false;

// Loads Meta's shared fbevents.js + defines window.fbq, without referencing any
// pixel ID. Callers are responsible for their own fbq('init', pixelId) afterwards.
// Safe to call multiple times; only injects the script once per page load.
export const ensureFbqLoaderLoaded = () => {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (typeof window.fbq === "function" || fbqLoaderInjected) return;
  fbqLoaderInjected = true;

  const fbq = function () {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
};

export const RESERVED_TOP_LEVEL_PATHS = new Set([
  "details", "dots", "dashboard", "download", "creators", "earn", "discover",
  "welcome-new-user", "login", "contact-us", "about-us", "terms-of-service-usa",
  "terms-of-service-india", "privacy-policy-usa", "privacy-policy-india", "faq",
  "guidelines-and-procedure", "refer-and-earn-tos", "create-share-earn-with-vasi",
  "marketplace-draw-tos", "task-creation-tos", "vasi-creator-monetisation-guidelines",
  "vasi-subscriber-guidelines", "deeplink", "dl", "share", "ask-vasi", "blogs",
  "experiences",
]);

// True for experience landing URLs (/:hostname/:experienceid and the Meta Ads
// /experiences/:hostname/:pixelid) and the matching pixel-keyed thank-you page
// (/experiences/:hostname/registration-success/:pixelid). Those pages init their own
// pixel, so the global pixel must stay out of the way — otherwise campaign traffic
// gets a double PageView.
export const isExperienceLandingRoute = (pathname) => {
  const segments = (pathname || "").split("/").filter(Boolean);
  if (segments.length === 3 && segments[0] === "experiences") return true;
  if (segments.length === 4 && segments[0] === "experiences" && segments[2] === "registration-success") return true;
  return segments.length === 2 && !RESERVED_TOP_LEVEL_PATHS.has(segments[0]);
};

// Top-level routes that run their own dedicated Meta pixel (see creatorMetaPixel.js
// for /creators) and must not also get the site-wide GlobalMetaPixel PageView.
const GLOBAL_PIXEL_EXCLUDED_TOP_LEVEL_PATHS = new Set(["creators"]);

export const isGlobalPixelExcludedRoute = (pathname) => {
  const segments = (pathname || "").split("/").filter(Boolean);
  return segments.length === 1 && GLOBAL_PIXEL_EXCLUDED_TOP_LEVEL_PATHS.has(segments[0]);
};